import { combineReducers } from '@reduxjs/toolkit';

import authReducer from 'features/auth/authSlice';
import uiReducer from 'features/ui/uiSlice';
import notificationReducer from 'features/notifications/notificationSlice';
import dashboardReducer from 'features/dashboard/dashboardSlice';

// Settings
import newspaperReducer from 'features/settings/newspaperMaster/newspaperSlice';
import roleReducer from 'features/settings/roles/roleSlice';
import userReducer from 'features/settings/users/userSlice';
import activityLogReducer from 'features/settings/activityLogs/activityLogSlice';
import systemConfigReducer from 'features/settings/systemConfig/systemConfigSlice';

// Shared
import newspaperOptionsReducer from 'features/shared/newspaperOptionsSlice';

// Pipeline
import stage1Reducer from 'features/stage1/stage1Slice';
import stage2Reducer from 'features/stage2/stage2Slice';
import briefingReducer from 'features/briefing/briefingSlice';
import storage1Reducer from 'features/storage1/storage1Slice';
import storage2Reducer from 'features/storage2/storage2Slice';
import ocrStorageReducer from 'features/ocrStorage/ocrStorageSlice';
import noStorageReducer from 'features/noStorage/noStorageSlice';
import searchReducer from 'features/search/searchSlice';

/**
 * Combine all feature reducers. Adding a feature = registering one reducer here.
 */
const rootReducer = combineReducers({
  auth: authReducer,
  ui: uiReducer,
  notifications: notificationReducer,
  dashboard: dashboardReducer,

  newspapers: newspaperReducer,
  roles: roleReducer,
  users: userReducer,
  activityLogs: activityLogReducer,
  systemConfig: systemConfigReducer,

  newspaperOptions: newspaperOptionsReducer,

  stage1: stage1Reducer,
  stage2: stage2Reducer,
  briefing: briefingReducer,
  storage1: storage1Reducer,
  storage2: storage2Reducer,
  ocrStorage: ocrStorageReducer,
  noStorage: noStorageReducer,
  search: searchReducer,
});

export default rootReducer;
